import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import { getScoreboard } from "../reducers/scoreboard";
import Loading from "../components/loading";

const CrownIcon = (props) => {
	switch(props.index) {
		case 0:
			return <img width={23} src={require("../img/Leader Scoreboard YELLOW CROWN.svg")} alt=""/>
		// case 1:
		// 	return <img width={23} src={require("../img/Leader Scoreboard BLUE CROWN.svg")} alt=""/>
		// case 2:
		// 	return <img width={23} src={require("../img/Leader Scoreboard SWORD.svg")} alt=""/>
		default:
			return null
	}
}

class HallOfFame extends Component {
	componentDidMount() {
		this.props.getScoreboard();
	}

	render() {
		let scoreboard = this.props.scoreboard.scoreboard;

		if(!scoreboard.length){
			return (
				<main className="">
					<section className="offer bg-color_gradient pl-1 pr-1">
						<h1>Hall of Fame</h1>
						<Loading />
					</section>
				</main>
			)
		}
			// scoreboard = this.props.scoreboard.tempScoreboard;

		return (
			<main className="">
				<section className="offer bg-color_gradient pl-1 pr-1">
					<h1>Hall of Fame</h1>
					<div className="score">
						<div className="score__title-block width">
							<div className="container">
								<div className="row">
									<div className="score__title">
										<p>Name</p>
									</div>
									<div className="score__title">
										<p>Rank</p>
									</div>
									<div className="score__title">
										<p>Skills</p>
									</div>
									<div className="score__title">
										<p>Score</p>
									</div>
								</div>
							</div>
						</div>
						{scoreboard.map((item, key) => {
							return (
								<div key={key} className="score__content width">
									<div className="container">
										<div className="row">
											<div className="score__name">
												<img src={require("../img/flags/"+item.Country.Code.toLowerCase()+".svg")} alt=""/>
												<div className="name">
													<h6>{item.User}</h6>
													<p>{item.Country.Name}</p>
												</div>
											</div>
											<div className="score__rank">
												<CrownIcon index={key} />
												<p>{key + 1}</p>
											</div>
											<div className="score__skills">
												<p>{item.Skills}</p>
											</div>
											<div className="score__score">
												<p>{item.Score}</p>
											</div>
										</div>
									</div>
								</div>
							)
						})}
					</div>
				</section>
			</main>
		);
	}
}

function mapStateToProps(state) {
	return {scoreboard: state.scoreboard};
}

const mapDispatchToProps = dispatch => bindActionCreators({
	getScoreboard
}, dispatch)

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(HallOfFame);